import { MaskLine, FadeUp } from "./Reveal";

const STACK = [
    {
        n: "01",
        title: "Motion Design",
        desc: "Show opens, title sequences, graphic packages, and visual identities that move.",
        id: "motion-design",
    },
    {
        n: "02",
        title: "Animation",
        desc: "Characters, concepts, and still things that need to come alive.",
        id: "animation",
    },
    {
        n: "03",
        title: "3D & CGI",
        desc: "Objects, environments, and product visuals built from nothing.",
        id: "3d-cgi",
    },
    {
        n: "04",
        title: "VFX",
        desc: "Impossible shots made convincing. Possible shots made better.",
        id: "vfx",
    },
    {
        n: "05",
        title: "Editing",
        desc: "Story and timing that give the visuals somewhere to go.",
        id: "editing",
    },
    {
        n: "06",
        title: "Ethical-AI Production",
        desc: "AI-assisted creative work with human direction, thoughtful production, and artists paid for their work.",
        id: "ethical-ai",
    },
];

export default function MoneyTalks() {
    return (
        <section
            id="money-talks"
            data-testid="money-talks-section"
            className="bg-white px-5 pb-20 pt-24 text-black md:px-8 md:pb-28 md:pt-36"
        >
            <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em] md:text-xs">
                <FadeUp>
                    <span className="text-mmm-red">002</span> — Money Talks: The business
                </FadeUp>
                <FadeUp className="hidden text-black/50 md:block">Annual review — Vol. 1</FadeUp>
            </div>

            <h2 className="mt-10 font-display text-[clamp(3rem,9vw,9.5rem)] uppercase leading-[0.88] md:mt-14">
                <MaskLine delay={0.05}>Having money</MaskLine>
                <MaskLine delay={0.13}>isn’t everything.</MaskLine>
                <MaskLine delay={0.21}>
                    <span className="text-mmm-red">Not having it is.</span>
                </MaskLine>
            </h2>

            <div className="mt-12 grid grid-cols-12 gap-6 md:mt-16">
                <FadeUp
                    delay={0.1}
                    className="col-span-12 max-w-[60ch] text-base leading-relaxed md:col-span-8 md:col-start-4 md:text-lg"
                >
                    <p data-testid="money-talks-body-1">
                        Money Mac Media is an independent creative company making
                        ambitious work for entertainment, brands, and anyone who’s been
                        told their idea is “a little too much.”
                    </p>
                    <p data-testid="money-talks-body-2" className="mt-4 text-black/60">
                        We take an idea from loose pitch to finished picture, or step
                        into an existing production and make the part everyone
                        remembers. Big ideas, expensive taste, and enough technical
                        skill to make the whole thing look suspiciously legitimate.
                    </p>
                </FadeUp>
            </div>

            <FadeUp className="mt-16 font-mono text-[10px] uppercase tracking-[0.22em] text-black/50 md:mt-24 md:text-xs">
                What we make: <span className="text-mmm-red">The money stack</span>
            </FadeUp>

            <div className="mt-6">
                {STACK.map((d, i) => (
                    <FadeUp key={d.id} delay={i * 0.03}>
                        <div
                            data-testid={`money-stack-${d.id}`}
                            className="group grid grid-cols-12 gap-3 border-t border-black/15 px-2 py-6 transition-colors duration-300 hover:bg-black hover:text-white md:px-4 md:py-8"
                        >
                            <span className="col-span-2 font-mono text-xs text-mmm-red md:col-span-1 md:text-sm">
                                ({d.n})
                            </span>
                            <div className="col-span-10 md:col-span-5">
                                <span className="block font-display text-2xl uppercase leading-none transition-transform duration-300 group-hover:translate-x-2 sm:text-4xl md:text-5xl">
                                    {d.title}
                                </span>
                            </div>
                            <p className="col-span-12 self-end text-sm leading-relaxed text-black/60 transition-colors duration-300 group-hover:text-white/60 md:col-span-6 md:text-base">
                                {d.desc}
                            </p>
                        </div>
                    </FadeUp>
                ))}
                <div className="border-t border-black/15" />
            </div>
        </section>
    );
}
